module.exports = __webpack_public_path__ + "img/angle-right-solid.fbb21171.svg";